export default __webpack_public_path__ + "img/a10b92081672a553e0b8b42c5e839dd2.svg";